export default "__VITE_ASSET__B1EhB3HD__"